module.exports = __webpack_public_path__ + "static/media/29FUNOV3.1aaa6141.jpg";